import { render, staticRenderFns } from "./white-slider.vue?vue&type=template&id=d89c6cee&scoped=true"
import script from "./white-slider.vue?vue&type=script&lang=js"
export * from "./white-slider.vue?vue&type=script&lang=js"
import style0 from "./white-slider.vue?vue&type=style&index=0&id=d89c6cee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89c6cee",
  null
  
)

export default component.exports